<template>
  <div class="file-upload-list">
    <div v-if="list && list.length > 0">
      <div class="file-upload-item" v-for="(item, index) in list" :key="index">
        <div class="item-box">
          <div class="item-box-top">
            <div class="item-box-top-left">
              <div class="item-box-top-icon"></div>
              <div class="item-box-top-title" :class="{'is-error': item.status === uploadStatus.CANCEL}">{{item.name}}</div>
            </div>
            <div class="item-box-top-right">
              <div class="item-box-top-text">{{item.size}}</div>
              <img v-if="item.status === uploadStatus.COMPLETE" src="@/assets/img/headline/select.svg" alt="" style="width: 14px"/>
              <div v-else-if="item.status === uploadStatus.ERROR" class="item-box-top-text is-error">上传中断</div>
              <div v-else-if="item.status === uploadStatus.CANCEL" class="item-box-top-text is-error">上传取消</div>
              <div v-else-if="item.status === uploadStatus.UP" class="item-box-top-text is-default">{{item.speed}}</div>
              <div v-else-if="item.status ===uploadStatus.WAIT" class="item-box-top-text is-default">上传等待</div>
              <div v-else class="item-box-top-text is-default"></div>
            </div>
          </div>
          <div class="item-box-progress">
            <el-progress :percentage="item.progress" color="#41B48C" :show-text="false"></el-progress>
          </div>
        </div>
        <div class="item-operate">
          <div v-if="item.status === uploadStatus.UP || item.status === uploadStatus.WAIT || item.status === uploadStatus.ERROR" class="operate-btn is-up" @click.stop="handleCancel(item)"></div>
          <div v-if="item.status === uploadStatus.ERROR" class="operate-btn is-refresh" @click.stop="handleRefresh(item)"></div>
          <div v-else-if="item.status === uploadStatus.COMPLETE && item.file_id && item.subject_type == 10" class="operate-btn is-ok" @click.stop="handleLink(item)"></div>
        </div>
      </div>
    </div>
    <div v-else class="content-empty">
      <img src="../../assets/img/common/newEmpty.png" alt="">
      <p>暂无内容</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'fileUploadList',
  data(){
    return {

    }
  },
  computed: {
    ...mapGetters('unifiedContentLibrary', ['getUploadList', 'getUploadStatus', 'getIsShowUploadModal', 'getContentInstance']),
    list(){
      return this.getUploadList
    },
    uploadStatus(){
      return this.getUploadStatus
    },
    showModal(){
      return this.getIsShowUploadModal
    },
    contentInstance(){
      return this.getContentInstance
    }
  },

  watch: {
    showModal(n) {
      if(n) {
        setTimeout(()=>{
          this.$emit('open')
          this.setIsShowUploadModal(undefined)
        })
      }else {
        this.setIsShowUploadModal(undefined)

      }
    }
  },

  methods: {
    ...mapActions('unifiedContentLibrary', ['setIsShowUploadModal']),
    handleCancel(item) {
      if(this.contentInstance) {
        // this.contentInstance.uploadBtnOperate.cancel(item.tid)
        this.$EventBus.$emit('library-upload-operate', {tid: item.tid, type: 'cancel'} )
      }
    },
    handleRefresh(item) {
      if(this.contentInstance) {
        // this.contentInstance.uploadBtnOperate.retry(item.tid)
        this.$EventBus.$emit('library-upload-operate', {tid: item.tid, type: 'retry'} )
      }
    },
    handleLink(item) {
      if(this.contentInstance) {
        // this.contentInstance.uploadBtnOperate.link(item.tid)
        this.$EventBus.$emit('library-upload-operate', {tid: item.tid, type: 'link'} )
      }
    },
    clearAll(){
      if(this.contentInstance) {
        // this.contentInstance.uploadBtnOperate.clearAll()
        this.$EventBus.$emit('library-upload-operate', {type: 'clearAll'} )
      }
    }
  }
}
</script>

<style lang="less" scoped>
.file-upload-list {
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(#dcdcdc, 0.3);
    border-radius: 4px;
  }

  .file-upload-item {
    display: flex;
    justify-content: space-between;
    height: 80px;
    box-sizing: border-box;
    padding-top: 12px;
    padding-left: 30px;
    &.is-active,
    &:hover {
      background: #F5F6F6;
    }
    .item-operate {
      display: flex;
      justify-content: center;
      width: 116px;
      .operate-btn {
        width: 36px;
        height: 36px;
        background: #F3FAF8;
        border-radius: 8px 8px 8px 8px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 14px 14px;
        margin-left: 5px;
        &:first-child {
          margin-left: 0px;
        }
        &.is-up {
          background-image: url("../../assets/img/headline/file-close.svg");
        }
        &.is-refresh {
          background-image: url("../../assets/img/headline/file-refresh.svg");
        }
        &.is-ok {
          background-image: url("../../assets/img/headline/file-fold.svg");
        }
      }
    }
    .item-box {
      flex: 1;
      overflow: hidden;
      .item-box-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &-left {
          display: flex;
          align-items: center;
          flex: 1;
          overflow: hidden;
        }
        &-right {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 130px;
        }

        &-text {
          font-weight: 400;
          font-size: 12px;
          color: #A8B3B3;
          &.is-default {
            color: #41B48C;
          }
          &.is-error {
            color: #FF565A;
          }
        }

        &-icon {
          width: 40px;
          height: 40px;
          border-radius: 6px 6px 6px 6px;
          background: rgba(65,180, 140, 0.06);
          background-image: url("../../assets/img/headline/file-upload.svg");
          background-position: center center;
          background-repeat: no-repeat;
          background-size: 20px 20px;
        }

        &-title {
          flex: 1;
          overflow: hidden;
          padding: 0 12px;
          font-weight: 500;
          font-size: 14px;
          color: #050F0F;
          text-overflow: ellipsis;
          white-space: nowrap;
          &.is-error {
            color: #FF565A;
          }
        }
      }
      .item-box-progress {
        padding-top: 5px;
      }
    }
  }
}

.content-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  p {
    font-size: 14px;
    line-height: 20px;
    color: #B9C3C3;
    font-weight: 500;
    margin-top: 14px;
  }
}

</style>
